import action from './action';

const Component = () => import('./OrderConfirmation');

export { Component, action };
